"use strict";
import simpleModal from "./simpleModal";

const modal = new simpleModal({
    id: 'LogOutModal',
    small: true,
    bodyClass: ' ',
    closeButton: false
});

const loadLogoutForm = async () => {
    await modal.loadContent({ url: '/site/auth/logout/form', data: {cid} });
};

export default async function () {
    await loadLogoutForm();
}

